import { useTranslation } from 'react-i18next'
import { FaRegSadTear } from 'react-icons/fa'

interface NoAnnouncesFoundProps {
  hasActiveFilters: boolean
}

export const NoAnnouncesFound: React.FC<NoAnnouncesFoundProps> = ({
  hasActiveFilters,
}) => {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col items-center justify-center text-center min-h-[150px] md:min-h-[200px] xl:min-h-[300px]  rounded-lg p-4'>
      <FaRegSadTear className='sm: text-2xl md:text-3xl xl:text-4xl text-redpink mb-4' />
      <h2 className='text-md md:text-lg xl:text-xl font-semibold text-gray-800 mb-4'>
        {t('no-announces-found')}
      </h2>
      <p className='text-sm md:text-base xl:text-md text-gray-600 max-w-md'>
        {hasActiveFilters
          ? t('no-announces-filtered-text')
          : t('no-announces-text')}
      </p>
    </div>
  )
}
